export default __webpack_public_path__ + "static/media/Eina01-Light.24b50907.woff";